import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { RESPONSIVE_STATE, ANALYTICS, MANAGE_LINE_CONST, COMMON_CONSTANTS } from '../common/core/common.constants';
import { isPlatformBrowser } from '@angular/common';
import { isNullOrUndefined } from 'src/app/services/utils';
import { environment } from "src/environments/environment";
import * as _ from 'lodash';
import { HttpCacheService } from './http-cache.service';
import { HelperUtilityService } from './helper-utility.service';
import { WindowServiceService } from './window-service.service';

declare global {
  interface Window {
    digitalData: any;
    triggerEvent: Function;
  }
}

@Injectable({
  providedIn: 'root'
})
export class PDLService {
  constructor(@Inject(PLATFORM_ID) private platform: any, private _cacheSvc?: HttpCacheService,
    private _helperUtilSvc?: HelperUtilityService, private _windowService?: WindowServiceService) {
      this.init()
     }
  responsiveState: any;
  init() {
    window.digitalData = window.digitalData || {};
    window.digitalData.page = window.digitalData.page || {};
    window.digitalData.page.category = window.digitalData.page.category || {};
    window.digitalData.page.pageInfo = window.digitalData.page.pageInfo || {};
    window.digitalData.events = window.digitalData.events || [];
    window.digitalData.user = window.digitalData.user || {};
    window.digitalData.customer = window.digitalData.customer || {};
    window.digitalData.customer.company = window.digitalData.customer.company || {};
  }

  generatePageViewTag(currentUrl: string, pageInfoDetails?: any) {
    const pageURI = currentUrl.split("?").shift();
    if (isPlatformBrowser(this.platform) && !isNullOrUndefined(environment.analytics) && !isNullOrUndefined(environment.analytics.pages[pageURI])) {
      const pageViewDetails = this.getPageViewDetails(pageInfoDetails, pageURI);
      window.digitalData.page.category = pageViewDetails.category;
      window.digitalData.page.pageInfo.pageName = pageViewDetails.pageInfo.pageName;
      window.digitalData.page.pageInfo.responsiveState = this.getResponsiveState();
      window.digitalData.page.pageInfo.pageURLFull = this._windowService.location.host + this._windowService.location.pathname;
      window.digitalData.page.pageInfo.previousPageURL = this.getFullPrevPageURL();
      window.digitalData.page.pageInfo.site = this.getSiteDetail();
      this.responsiveState = window.digitalData.page.pageInfo.responsiveState;

      const singleBan = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage('singleBanUser')) ? this._cacheSvc.getFromSessionStorage('singleBanUser') : '';

      window.digitalData.customer = {
        company: {
          banType: COMMON_CONSTANTS.MULTIBAN
        }
      }
      if (!isNullOrUndefined(singleBan) && singleBan === MANAGE_LINE_CONST.Y_CTA) {
        window.digitalData.customer = {
          company: {
            banType: COMMON_CONSTANTS.SINGLEBAN
          }
        }
      }

      const orgName = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ORGNAME)) ? this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ORGNAME) : '';
      this.callsWhenOrgName(orgName);
      const isOkta = this._helperUtilSvc.getAuthType() !== COMMON_CONSTANTS.IAM_KEY;
      window.digitalData.user = {};
      window.digitalData.user['userType'] = COMMON_CONSTANTS.CUSTOMER;
      this.callsWhenOkta(isOkta);

      window.digitalData.user['userState'] = COMMON_CONSTANTS.AUTHENTICATED;
      const event = pageViewDetails.event;
      window.digitalData.events.push(event);
      this.triggerEvent();
    }

  }

  callsWhenOrgName(orgName){
    if (orgName) {
      window.digitalData.customer.company['name'] = orgName;
    }
  }

  callsWhenOkta(isOkta){
    if (isOkta) {
      window.digitalData.user['userType'] = COMMON_CONSTANTS.CARE;
    }
    else {
      window.digitalData.user['userType'] = COMMON_CONSTANTS.CUSTOMER;
    }
  }


  generateClickTag(clickTagDetails) {
    if (isPlatformBrowser(this.platform)) {
      this.addTagElementes(clickTagDetails);
    }
  }

  addTagElementes(clickTagDetails){
    const event = {
      eventInfo: {
        eventType: clickTagDetails.type,
        eventAction: clickTagDetails.action
      },
      category: {
      },
      eventDescription: {
      },
      selfService: {
      }
    };
    if (!isNullOrUndefined(clickTagDetails.ctaName)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.CTA_NAME, clickTagDetails.ctaName);
    }
    if (!isNullOrUndefined(clickTagDetails.assetType)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.ASSET_TYPE, clickTagDetails.assetType);
    }
    if (!isNullOrUndefined(clickTagDetails.userSelection)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.USER_SELECTION, clickTagDetails.userSelection);
    }
    if (!isNullOrUndefined(clickTagDetails.modalName)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.MODAL_NAME, clickTagDetails.modalName);
    }
    if (!isNullOrUndefined(clickTagDetails.formName)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.FORM_NAME, clickTagDetails.formName);
    }
    if (!isNullOrUndefined(clickTagDetails.storeID)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.STORE_ID, clickTagDetails.storeID);
    }
    if (!isNullOrUndefined(clickTagDetails.PlacementID)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.PLACEMENT_ID, clickTagDetails.PlacementID);
    }
    if (!isNullOrUndefined(clickTagDetails.dataAnalyticsID)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.DATA_ANALYTICS_ID, clickTagDetails.dataAnalyticsID);
    }
    if (!isNullOrUndefined(clickTagDetails.ModuleName)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.MODULE_NAME, clickTagDetails.ModuleName);
    }
    if (!isNullOrUndefined(clickTagDetails.parentComponent)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.PARENT_COMPONENT, clickTagDetails.parentComponent);
    }
    if (!isNullOrUndefined(clickTagDetails.stage)) {
      this.addElementToObject(event.selfService, ANALYTICS.STAGE, clickTagDetails.stage);
    }
    if (!isNullOrUndefined(clickTagDetails.name)) {
      this.addElementToObject(event.selfService, ANALYTICS.NAME, clickTagDetails.name);
    }
    if (!isNullOrUndefined(clickTagDetails.eventCategory)) {
      this.addElementToObject(event.category, ANALYTICS.EVENTCATEGORY, clickTagDetails.eventCategory);
    }
    if (!isNullOrUndefined(clickTagDetails.alertInfo)) {
      this.addElementToObject(event.eventDescription, ANALYTICS.ALERTINFO, clickTagDetails.alertInfo);
    }
    window.digitalData.events.push(event);
    this.triggerEvent();
  }

  generateModalViewTag(modalDetails) {
    if (isPlatformBrowser(this.platform)) {
      this.addTagElementToModalView(modalDetails);
    }
  }

  addTagElementToModalView(modalDetails) {
    const event = {
      eventInfo: {
        eventType: ANALYTICS.MODAL,
        eventAction: modalDetails.eventAction
      },
      attributes: {
        modalName: modalDetails.modalName
      },
      selfService: {
      },
      error: [],

    };
    if (!isNullOrUndefined(modalDetails.stage)) {
      this.addElementToObject(event.selfService, ANALYTICS.STAGE, modalDetails.stage);
    }
    if (!isNullOrUndefined(modalDetails.name)) {
      this.addElementToObject(event.selfService, ANALYTICS.NAME, modalDetails.name);
    }
    if (!isNullOrUndefined(modalDetails.eventType)) {
      this.addElementToObject(event.eventInfo, ANALYTICS.EVENTTYPE, modalDetails.eventType);
    }
    if (!isNullOrUndefined(modalDetails.error)) {
      _.each(modalDetails.error, (item) => {
        event.error.push(item);
      });
    }
    if (!isNullOrUndefined(modalDetails.socPageContent)) {
      this.addElementToObject(event.attributes, ANALYTICS.SOCPAGECONTENT, modalDetails.socPageContent);
    }
    if (!isNullOrUndefined(modalDetails.currentlyActiveServices)) {
      this.addElementToObject(event.attributes, ANALYTICS.CURRENTLYACTIVESERVICES, modalDetails.currentlyActiveServices);
    }
    if (!isNullOrUndefined(modalDetails.UpdatedVoicePlan)) {
      this.addElementToObject(event.attributes, ANALYTICS.UPDATEDVOICEPLAN, modalDetails.UpdatedVoicePlan);
    }
    if (!isNullOrUndefined(modalDetails.updatedServices)) {
      this.addElementToObject(event.attributes, ANALYTICS.UPDATEDSERVICES, modalDetails.updatedServices);
    }
    if (!isNullOrUndefined(modalDetails.netPrice)) {
      this.addElementToObject(event.attributes, ANALYTICS.NETPRICE, modalDetails.netPrice);
    }
    if (!isNullOrUndefined(modalDetails.item)) {
      event['item'] = modalDetails.item;
    }
    if (!isNullOrUndefined(modalDetails.dynamicContent)) {
      this.addElementToObject(event.attributes, ANALYTICS.DYNAMICCONTENT, modalDetails.dynamicContent);
    }
    if (!isNullOrUndefined(modalDetails.alert)) {
      event['alert'] = modalDetails.alert;
    }
    window.digitalData.events.push(event);
    this.triggerEvent();
  }

  ifEnabledGeneratePageViewTag(currentUrl: string, pageInfoDetails?: any) {
    if (environment.ENABLE_TAGGING) {
      this.generatePageViewTag(currentUrl, pageInfoDetails);
    }
  }

  ifEnabledGenerateModalViewTag(modalInfo) {
    if (environment.ENABLE_TAGGING) {
      this.generateModalViewTag(modalInfo);
    }
  }

  ifEnabledGenerateClickTag(clickEventInfo) {
    if (environment.ENABLE_TAGGING) {
      this.generateClickTag(clickEventInfo);
    }
  }

  private getResponsiveState(): string {
    if (window.matchMedia('(max-width: 600px)').matches) {
      return RESPONSIVE_STATE.MOBILE;
    } else if (
      window.matchMedia('(min-width: 600px) and (max-width: 1024px)').matches
    ) {
      return RESPONSIVE_STATE.TABLET;
    } else {
      return RESPONSIVE_STATE.DESKTOP;
    }
  }

  private addElementToObject(object: any, key: string, value: string) {
    if (value) {
      object[key] = value;
    }
  }

  private triggerEvent() {
    if (typeof window.triggerEvent === "function") {
      window.triggerEvent();
    }
  }

  private getPageViewDetails(pageInfoDetails, pageURI) {
    const pageViewDetails = JSON.parse(JSON.stringify(environment.analytics.pages[pageURI]));
    // Add currently selected tab to pageName
    if (pageInfoDetails && pageInfoDetails.tabName) {
      pageViewDetails.pageInfo.pageName += pageInfoDetails.tabName;
      pageViewDetails.event.read = false;
      return pageViewDetails
    }

    if (!isNullOrUndefined(pageInfoDetails)) {
      pageViewDetails.category = pageInfoDetails.category;
      pageViewDetails.pageInfo.pageName = pageInfoDetails.pageInfo.pageName;
      pageViewDetails.event.selfService = pageInfoDetails.event.selfService;
      pageViewDetails.event.read = false;
    }
    return pageViewDetails;
  }

  private getFullPrevPageURL(): string {
    const urlPath = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ROUTES_TXT);
    if (urlPath == null || !urlPath.includes('prevUrl')) {
      return '';
    }
    return this._windowService.location.host + JSON.parse(urlPath).prevUrl;
  }

  private getSiteDetail(): string {
    const authType = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE)
    if (authType !== COMMON_CONSTANTS.IAM_KEY) {
      return ANALYTICS.SITE_CARE;
    }
    return  ANALYTICS.SITE_AHUB;
  }
}
